
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.813 3c0-1.105.839-2 1.875-2h3.074c.403 0 .762.275.89.684l1.403 4.493c.148.472-.052.988-.47 1.21L6.47 8.518c1.033 2.444 2.88 4.414 5.172 5.516l1.058-2.257c.209-.445.692-.66 1.135-.502l4.213 1.498c.382.136.64.518.64.949V17c0 1.105-.839 2-1.875 2h-.937C8.108 19 1.812 12.284 1.812 4V3z","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    